<template>
  <div>
    <loading-screen/>
    <div class="login-screen">
      <h1>Admin Panel Borkconnector</h1>
      <div>
        <label for="emailadres">Username</label><br/>
        <input @keyup.enter="submit" :class="{ 'is-invalid': invalidLogin }" class="form-control rounded-0 border-1 py-4 bg-light"
               type="email" id="emailadres" name="emailadres" v-model="email">
      </div>
      <div>
        <label for="password">Password</label><br/>
        <input  @keyup.enter="submit" :class="{ 'is-invalid': invalidLogin }" class="form-control rounded-0 border-1 py-4 bg-light"
               type="password" id="password" name="password" v-model="password">
      </div>
      <div v-if="invalidLogin">
        <label class="invalid-text">Invalid username or password</label>
      </div>
      <div>
        <button class="btn btn-secondary" @click="submit()">Login</button>
      </div>
    </div>
  </div>
</template>

<script>
import {LoadingScreen} from 'motivate-framework-components';
import {login, isLoggedIn} from '@/firebase/login';
import firebase from 'firebase/app';
import 'firebase/auth';
// @vuese
// @group Wrappers
// Main page wrapper
export default {
  name: 'Login',
  components: {
    LoadingScreen
  },
  data() {
    return {
      invalidLogin: false,
      email: '',
      password: ''
    };
  },
  firestore() {
    return {};
  },
  methods: {
    async submit() {
      this.$store.commit('setLoading', true);
      const result = await login(this.email, this.password).catch(() => {
        this.invalidLogin = true;
      });
      this.$store.commit('setLoading', false);
      if (result) {
        await this.$router.push({name: 'home' });
      }
    },
  },
  computed: {},
  watch: {},
  created() {
    this.$store.commit('setLoading', false);
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        var uid = user.uid;
        this.$router.push({name: 'home'});

        // ...
      } else {
        // User is signed out
        // ...
      }
    });
    if (isLoggedIn()) {
      this.$router.push({name: 'home'});

    }
  }
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/main.scss";

h1 {
  color: $primary;
}

input {
  width: 90%;
  padding: 5px;

}

button {
  width: 20%;
}

.login-screen {
  text-align: center;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  grid-column-gap: 12px;
  grid-row-gap: 12px;
}

.form-control {
  display: inline;
}

.invalid-text {
  color: red;
}
</style>
